import { ShareInfoFragment } from '@sketch/gql-types'
import React from 'react'
import {
  ShareActionsDropdown,
  ShareForShareDropdown,
} from 'modules/shares/components/ShareActionsDropdown'
import {
  ShareActionsDropdownTrashed,
  ShareForTrashedActionsDropdown,
} from 'modules/shares/components/ShareActionsDropdownTrashed'
import { useDuplicateShare } from 'modules/shares/hooks/useDuplicateShare'

import {
  DropdownButton,
  DropdownButtonEllipsis,
} from '../DocumentItem/DocumentItem.styles'

import { useResponsiveDropdown } from 'components/ResponsiveDropdown'

export interface DocumentItemDropdownProps {
  share: ShareForShareDropdown &
    ShareForTrashedActionsDropdown &
    Pick<ShareInfoFragment, 'deletedAt'> & {
      __typename: 'Share' | 'TrashedShare'
    }
  workspaceIdentifier: string
}

export const DocumentItemDropdown = (props: DocumentItemDropdownProps) => {
  const { share, workspaceIdentifier } = props

  const version = share.version!

  const [duplicateShare] = useDuplicateShare({
    share,
    versionIdentifier: version.identifier,
    workspaceIdentifier,
  })

  const [content, buttonProps] = useResponsiveDropdown({
    dropdown: ShareActionsDropdown,
    dropdownProps: {
      share,
      versions: { current: version, latest: version },
      isViewingLatestVersion: true,
      onDuplicateShareClick: duplicateShare,
    },
    placement: 'bottom',
    usePortal: true,
  })

  const [
    contentForDeleteDropdown,
    buttonPropsDeleteDropdown,
  ] = useResponsiveDropdown({
    dropdown: ShareActionsDropdownTrashed,
    dropdownProps: {
      share,
    },
    placement: 'bottom-end',
    usePortal: true,
  })

  if (!share.deletedAt && share.__typename === 'Share') {
    return (
      <div onClick={event => event.stopPropagation()}>
        <DropdownButton {...buttonProps}>
          <DropdownButtonEllipsis aria-label="Document Settings" />
          <span className="sr-only">Document Settings</span>
        </DropdownButton>
        {content}
      </div>
    )
  }

  if (share.deletedAt) {
    return (
      <div onClick={event => event.stopPropagation()}>
        <DropdownButton {...buttonPropsDeleteDropdown}>
          <DropdownButtonEllipsis aria-label="Document Settings" />
          <span className="sr-only">Document Settings</span>
        </DropdownButton>
        {contentForDeleteDropdown}
      </div>
    )
  }

  return null
}
